'use client';

import React from 'react';
import { useFormContext } from '@jucy-ui/forms';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import IconButton from '@mui/material/IconButton';
import { SearchFormValues } from '../../../SearchForm';
import { useSearchFormStore } from '../../../SearchForm/hooks/useSearchFormStore';
import { jucySearchFormClasses } from '../../../SearchForm/lib/jucySearchFormClasses';

export const TripFieldsSeparatorArrow: React.FC<{ variant?: 'horizontal' | 'vertical' | 'wide' }> = () => {
    const { showReverseTripButton, onTripReversed } = useSearchFormStore();
    const { getValues, setValue } = useFormContext<SearchFormValues>();
    return showReverseTripButton ? (
        <IconButton
            className={jucySearchFormClasses.dateTimeArrow}
            sx={(theme) => ({
                backgroundColor: theme.palette.common.white,
                position: 'absolute',
                border: '1px solid rgba(0, 0, 0, 0.23)',
                zIndex: 1,
                transition: theme.transitions.create(['background-color', 'border-color'], {
                    duration: theme.transitions.duration.shortest,
                }),
                '&:hover': {
                    backgroundColor: theme.palette.grey[100],
                    border: '1px solid rgba(0, 0, 0, 0.54)',
                },
            })}
            onClick={() => {
                const currentPickUp = getValues('pickUpBranch');
                const currentDropOff = getValues('dropOffBranch');
                setValue('pickUpBranch', currentDropOff);
                setValue('dropOffBranch', currentPickUp);
                onTripReversed?.(getValues());
            }}
            aria-label="delete"
            size="small"
        >
            <SwapHorizIcon fontSize="small" />
        </IconButton>
    ) : (
        <ArrowForwardIcon
            className={jucySearchFormClasses.dateTimeArrow}
            sx={{
                color: 'rgba(0, 0, 0, 0.23)',
                fontSize: 22,
                position: 'absolute',
            }}
        />
    );
};
